getPmScreenProcessing